"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptType = exports.CONTENT_SIDEBAR_TABS = exports.contentSidebarTabToSidebarTabTypeTelem = exports.ContentSidebarTab = void 0;
var SidebarViewStore_1 = require("Project/Stores/SidebarViewStore/SidebarViewStore");
var mobx_1 = require("mobx");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var ContentSidebarTab;
(function (ContentSidebarTab) {
    ContentSidebarTab["Blocks"] = "contentsidebartab:blocks";
    ContentSidebarTab["Image"] = "contentsidebartab:image";
})(ContentSidebarTab || (exports.ContentSidebarTab = ContentSidebarTab = {}));
var contentSidebarTabToSidebarTabTypeTelem = function (tab) {
    var _a;
    return (_a = {},
        _a[ContentSidebarTab.Blocks] = TelemetryEnums_1.SidebarTabType.Blocks,
        _a[ContentSidebarTab.Image] = TelemetryEnums_1.SidebarTabType.Images,
        _a)[tab];
};
exports.contentSidebarTabToSidebarTabTypeTelem = contentSidebarTabToSidebarTabTypeTelem;
exports.CONTENT_SIDEBAR_TABS = [
    { key: ContentSidebarTab.Blocks, displayName: "Blocks" },
    { key: ContentSidebarTab.Image, displayName: "Images" },
];
var PromptType;
(function (PromptType) {
    PromptType["ClickOrDragToAddImage"] = "ClickOrDragToAddImage";
})(PromptType || (exports.PromptType = PromptType = {}));
var Prompts = (_a = {},
    _a[PromptType.ClickOrDragToAddImage] = {
        class: "click-or-drag-prompt",
        text: "Click or drag to add image",
    },
    _a);
var ContentSidebarViewStore = (function () {
    function ContentSidebarViewStore(sidebarViewStore, telemetry, editorState, blockList, dropzonesStore) {
        var _this = this;
        this.sidebarViewStore = sidebarViewStore;
        this.telemetry = telemetry;
        this.editorState = editorState;
        this.blockList = blockList;
        this.dropzonesStore = dropzonesStore;
        this._showFolders = false;
        this._currentTab = ContentSidebarTab.Blocks;
        this._shouldFocusSidebarCloseBtn = false;
        this._currentPrompt = Prompts[PromptType.ClickOrDragToAddImage];
        this._isShowingPrompt = false;
        this.hideFolders = function () {
            _this._showFolders = false;
        };
        this.toggleFolderTree = function () {
            _this._showFolders = !_this._showFolders;
        };
        this.showPrompt = function (type, timeInMS) {
            if (timeInMS === void 0) { timeInMS = 5000; }
            _this._currentPrompt = Prompts[type];
            _this._isShowingPrompt = true;
            setTimeout(function () {
                (0, mobx_1.runInAction)(function () {
                    _this.hidePrompt();
                });
            }, timeInMS);
        };
        this.hidePrompt = function () {
            _this._isShowingPrompt = false;
        };
        this.setCurrentTab = function (newTab) {
            if (_this._currentTab === ContentSidebarTab.Blocks && newTab !== ContentSidebarTab.Blocks) {
                _this.dropzonesStore.clearPersistent();
                _this.dropzonesStore.clearActiveDropzone();
            }
            _this._currentTab = newTab;
        };
        this.setShouldFocusSidebarCloseBtn = function (newValue) {
            _this._shouldFocusSidebarCloseBtn = newValue;
        };
        this.closeFolders = function () {
            _this._showFolders = false;
        };
    }
    Object.defineProperty(ContentSidebarViewStore.prototype, "isOpen", {
        get: function () {
            return this.sidebarViewStore.sidebarIsOpen(SidebarViewStore_1.SidebarType.ContentSidebar);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContentSidebarViewStore.prototype, "currentTab", {
        get: function () {
            return this._currentTab;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContentSidebarViewStore.prototype, "currentPrompt", {
        get: function () {
            return this._currentPrompt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContentSidebarViewStore.prototype, "isShowingPrompt", {
        get: function () {
            return this._isShowingPrompt;
        },
        enumerable: false,
        configurable: true
    });
    ContentSidebarViewStore.prototype.isTabCurrentlyOpen = function (tab) {
        var _this = this;
        return (0, mobx_1.computed)(function () { return _this.isOpen && _this._currentTab === tab; }).get();
    };
    ContentSidebarViewStore.prototype.toggle = function () {
        if (this.isOpen) {
            this.close();
        }
        else {
            this.open(TelemetryEnums_1.SidebarOpenOrigin.LibraryButton);
        }
    };
    Object.defineProperty(ContentSidebarViewStore.prototype, "showFolders", {
        get: function () {
            return this._showFolders;
        },
        enumerable: false,
        configurable: true
    });
    ContentSidebarViewStore.prototype.open = function (origin, tab) {
        if (tab) {
            this.setCurrentTab(tab);
        }
        if (this.isOpen) {
            return;
        }
        this.sidebarViewStore.openSidebar(SidebarViewStore_1.SidebarType.ContentSidebar);
        var editSessionTime = this.editorState.getEditSessionTime();
        this.editorState.startSidebarSession();
        this.telemetry.trackOnly("Sidebar Opened", {
            sidebar_opened_project_edit_session_duration: editSessionTime,
            sidebar_opened_blocks_number: this.blockList.getLength(),
            sidebar_opened_origin: origin,
            sidebar_tab_type: (0, exports.contentSidebarTabToSidebarTabTypeTelem)(this.currentTab),
        });
    };
    ContentSidebarViewStore.prototype.close = function () {
        this.hideFolders();
        this.sidebarViewStore.closeSidebar();
        this.dropzonesStore.clearPersistent();
        this.dropzonesStore.clearActiveDropzone();
        this._shouldFocusSidebarCloseBtn = false;
        this.telemetry.trackOnly("Sidebar Closed", {
            sidebar_closed_app_session_duration: this.editorState.getSidebarSessionTime(),
            sidebar_closed_blocks_added_number: this.editorState.getNumBlocksAddedInCurrentSidebarSession(),
        });
    };
    Object.defineProperty(ContentSidebarViewStore.prototype, "shouldFocusSidebarCloseBtn", {
        get: function () {
            return this.isOpen && this._shouldFocusSidebarCloseBtn;
        },
        enumerable: false,
        configurable: true
    });
    var _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], ContentSidebarViewStore.prototype, "_showFolders", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "_currentTab", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "_shouldFocusSidebarCloseBtn", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "_currentPrompt", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "_isShowingPrompt", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ContentSidebarViewStore.prototype, "isOpen", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "hideFolders", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "toggleFolderTree", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ContentSidebarViewStore.prototype, "currentTab", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ContentSidebarViewStore.prototype, "currentPrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ContentSidebarViewStore.prototype, "isShowingPrompt", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "showPrompt", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "hidePrompt", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "setCurrentTab", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ContentSidebarViewStore.prototype, "toggle", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ContentSidebarViewStore.prototype, "showFolders", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof TelemetryEnums_1.SidebarOpenOrigin !== "undefined" && TelemetryEnums_1.SidebarOpenOrigin) === "function" ? _b : Object, String]),
        __metadata("design:returntype", void 0)
    ], ContentSidebarViewStore.prototype, "open", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "setShouldFocusSidebarCloseBtn", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], ContentSidebarViewStore.prototype, "closeFolders", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ContentSidebarViewStore.prototype, "close", null);
    return ContentSidebarViewStore;
}());
exports.default = ContentSidebarViewStore;
